import { useQuery } from "@tanstack/react-query";
import { getAllGalleries } from "../../../services/galleryServices";
import GalleryListingPage from "../../../components/admin/gallery/GalleryListingPage";
import { useState, useEffect } from "react"; // Add useEffect import
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import Pagination from "../../../components/admin/common/Pagination";

const GalleryListing = () => {
  const [lastId, setLastId] = useState();
  const [statusFilter, setStatusFilter] = useState("active");
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 8;

  const {
    data: galleries,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["galleries", { lastId, limit, status: statusFilter }],
    queryFn: () => getAllGalleries(lastId, limit, statusFilter),
    keepPreviousData: true,
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [currentPage, statusFilter]);

  const handleNextPage = () => {
    if (galleries?.data?.nextLastId) {
      setLastId(galleries.data.nextLastId);
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setLastId(undefined);
      setCurrentPage(1);
    }
  };

  const handleStatusFilterChange = (newStatus) => {
    setStatusFilter(newStatus);
    setLastId(undefined);
    setCurrentPage(1);
  };

  const hasMore = galleries?.data?.hasMore || false;

  return (
    <>
      <Header />
      <GalleryListingPage
        galleries={galleries?.data?.data || []}
        isLoading={isLoading}
        isError={isError}
        error={error}
        onStatusFilterChange={handleStatusFilterChange}
        currentStatusFilter={statusFilter}
      />
      {galleries?.data?.data && galleries.data.data.length > 0 && (
        <div className="container mx-auto pb-8">
          <Pagination
            currentPage={currentPage}
            hasMore={hasMore}
            onPrevious={handlePrevPage}
            onNext={handleNextPage}
          />
        </div>
      )}
      <Footer />
    </>
  );
};

export default GalleryListing;
